import { gsap } from "gsap";

document.addEventListener("DOMContentLoaded", () => {
  const card = document.getElementById("expandableCard");
  if (!card)
	return;

  const closeBtn = document.getElementById("closeBtn");
  const cardPreview = card.querySelector(".card-preview");
  const cardContent = card.querySelector(".card-content");
  const logoPaths = document.querySelectorAll(".logo-path");

  let isExpanded = false;
  let hasBeenOpened = false; // State flag to track first open/close cycle

  // Create Pixel Grid Overlay Dynamic Elements
  const pixelOverlay = document.createElement("div");
  pixelOverlay.className = "pixel-overlay";
  card.appendChild(pixelOverlay);

  const GRID_ROWS = 6;
  const GRID_COLS = 10;
  const totalPixels = GRID_ROWS * GRID_COLS;
  const pixels = [];

  for (let i = 0; i < totalPixels; i++) {
    const pixel = document.createElement("div");
    pixel.className = "pixel-block";
    pixelOverlay.appendChild(pixel);
    pixels.push(pixel);
  }

  // Open Animation
  function expandCard() {
    if (isExpanded) return;
    isExpanded = true;

    card.classList.add("is-expanded");

    const tl = gsap.timeline();

    // 1. Hide preview content
    tl.to(cardPreview, {
      opacity: 0,
      duration: 0.1,
      onComplete: () => {
        cardPreview.style.pointerEvents = "none";
      }
    })
    // 2. Expand container bounds (transparent)
    .to(card, {
      width: "100vw",
      height: "100vh",
      bottom: 0,
      right: 0,
      borderRadius: "0px",
      duration: 0.01
    })
    // 3. Display grid container
    .set(pixelOverlay, { display: "grid" })
    // 4. Staggered reveal of pixel tiles
    .fromTo(
      pixels,
      { opacity: 0, scale: 0 },
      {
        opacity: 1,
        scale: 1,
        duration: 0.35,
        stagger: {
          amount: 0.4,
          grid: [GRID_ROWS, GRID_COLS],
          from: "bottom-right"
        },
        ease: "power2.out"
      }
    )
    // 5. Reveal overlay content
    .to(cardContent, {
      opacity: 1,
      duration: 0.2,
      onStart: () => {
        cardContent.style.pointerEvents = "auto";
      }
    })
    .fromTo(
      logoPaths,
      { opacity: 0, y: 30, scale: 0.85 },
      {
        opacity: 1,
        y: 0,
        scale: 1,
        duration: 0.4,
        stagger: 0.03,
        ease: "back.out(1.7)"
      },
      "-=0.1"
    );
  }

  // Close Animation (Transforms button into compact icon view)
  function shrinkCard(e) {
    e.stopPropagation();
    if (!isExpanded) return;

    hasBeenOpened = true; // Mark as closed after first interaction

    const tl = gsap.timeline({
      onComplete: () => {
        card.classList.remove("is-expanded");
        pixelOverlay.style.display = "none";
        isExpanded = false;
      }
    });

    tl.to(logoPaths, {
      opacity: 0,
      y: -15,
      duration: 0.15,
      stagger: 0.01
    })
    .to(cardContent, {
      opacity: 0,
      duration: 0.15,
      onStart: () => {
        cardContent.style.pointerEvents = "none";
      }
    })
    .to(pixels, {
      opacity: 0,
      scale: 0,
      duration: 0.3,
      stagger: {
        amount: 0.3,
        grid: [GRID_ROWS, GRID_COLS],
        from: "center"
      },
      ease: "power2.in"
    })
    // Shrink container down to a square icon badge dimensions
    .to(card, {
      width: "60px",
      height: "60px",
      bottom: "24px",
      right: "24px",
      borderRadius: "16px",
      duration: 0.3,
      ease: "power3.inOut",
      onStart: () => {
        if (hasBeenOpened) {
          // Hide text and arrow elements
          const btnText = card.querySelector(".btn-text");
          const arrowIcon = card.querySelector(".arrow-icon");
          const appIconSvg = card.querySelector(".app-icon svg");

          if (btnText) btnText.style.display = "none";
          if (arrowIcon) arrowIcon.style.display = "none";
          
          // Remove icon blur and adjust preview padding
          if (appIconSvg) appIconSvg.style.filter = "none";
          cardPreview.style.padding = "0";
          cardPreview.style.justifyContent = "center";
        }
      }
    })
    .to(cardPreview, {
      opacity: 1,
      duration: 0.15,
      onStart: () => {
        cardPreview.style.pointerEvents = "auto";
      }
    });
  }

  card.addEventListener("click", expandCard);
  closeBtn.addEventListener("click", shrinkCard);
});